// extracted by mini-css-extract-plugin
export default {"yellowButtonContainer":"YellowButton__yellowButtonContainer--Jr","yellowButton":"YellowButton__yellowButton--zF"};